import { ACTUAL_ENV, Environment, valuesFromProcess } from '@/core/lib/env/env.context';
import api from '@/core/lib/fetch/api';
import { StripeBodySchema, StripeCheckoutSession, stripeCheckoutSessionSchema, StripeCreateSessionResponse, stripeCreateSessionResponseSchema } from '@/core/types/stripe';

const getUrl = () => valuesFromProcess[ACTUAL_ENV as Environment]?.BASE_URL;

const query = {
  getCheckoutSession: async (checkoutSessionId: string) =>
    api.get<StripeCheckoutSession>({
      url: `${getUrl()}/api/stripe/${checkoutSessionId}/get-checkout-session`,
      schema: stripeCheckoutSessionSchema,
    }),
};

const mutation = {
  createCheckoutSession: async (data: StripeBodySchema) =>
    api.post<StripeCreateSessionResponse, StripeBodySchema>({
      url: `${getUrl()}/api/stripe/create-session`,
      data,
      schema: stripeCreateSessionResponseSchema,
    }),
};

export default { mutation, query };
